import { MessageBubble } from './MessageBubble';
import type { PortalMessage } from '@/types';

interface ConversationThreadProps {
  messages: PortalMessage[];
  requesterEmail: string;
}

export function ConversationThread({ messages, requesterEmail }: ConversationThreadProps) {
  if (messages.length === 0) {
    return (
      <div className="py-8 text-center text-muted-foreground">
        No messages yet.
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {messages.map((message) => {
        // Determine if the message is from the requester:
        // 1. Match sender_email against requester_email
        // 2. If sender_email is null (legacy milter data), fall back to sender_type === 'request'
        const isRequester = message.sender_email
          ? message.sender_email.toLowerCase() === requesterEmail.toLowerCase()
          : message.sender_type === 'request';

        return (
          <MessageBubble
            key={message.id}
            message={message}
            isRequester={isRequester}
          />
        );
      })}
    </div>
  );
}
